/**
 * HTTP response status codes supported by transport packet.
 * @type {object}
 */
export const RESPONSE_CODES = {
	OK: 200,
	INVALID: 206,
	WARNING: 400,
	UNAUTHORIZED: 401,
	FORBIDDEN: 403,
	NOT_FOUND: 404,
	TEAPOT: 418,
	ERROR: 500,
};
